import inputFormikFactory from './inputFormikFactory';

export default inputFormikFactory({ valueFormatter: value => value.toUpperCase() });
